/* eslint-disable */
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';

export class SwaggerException extends Error {
  override message: string;
  status: number;
  response: string;
  headers: {
    [key: string]: any;
  };
  result: any;
  constructor(
    message: string,
    status: number,
    response: string,
    headers: {
      [key: string]: any;
    },
    result: any,
  ) {
    super();
    this.message = message;
    this.status = status;
    this.response = response;
    this.headers = headers;
    this.result = result;
  }
  protected isSwaggerException = true;
  static isSwaggerException(obj: any): obj is SwaggerException {
    return obj.isSwaggerException === true;
  }
}

export function throwException(
  message: string,
  status: number,
  response: string,
  headers: {
    [key: string]: any;
  },
  result?: any,
): Observable<any> {
  if (result !== null && result !== undefined) return _observableThrow(result);
  else return _observableThrow(new SwaggerException(message, status, response, headers, null));
}

export function blobToText(blob: any): Observable<string> {
  return new Observable<string>((observer: any) => {
    if (!blob) {
      observer.next('');
      observer.complete();
    } else {
      let reader = new FileReader();
      reader.onload = event => {
        observer.next((event.target as any).result);
        observer.complete();
      };
      reader.readAsText(blob);
    }
  });
}
